import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./BackToTopButton.css";

const BackToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          type="button"
          aria-label="Back to top"
          onClick={scrollToTop}
          className="back-to-top"
          initial={{ opacity: 0, y: 20, scale: 0.85 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.85 }}
          transition={{ type: "spring", stiffness: 280, damping: 22 }}
          whileHover={{ y: -3 }}
          whileTap={{ scale: 0.94 }}
        >
          <span className="back-to-top-arrow">↑</span>
          <span className="back-to-top-label">Top</span>
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default BackToTopButton;
